import ViewRecord from "records/view";

export const viewDefData = {
    _id: "58a4da35c28cc40001bcda94",
    brand: "58a4da34c28cc40001bcda12",
    view_name: "item_tile",
    active: true,
    sections: [
        {
            key: "details",
            elements: [
                {
                    type: "field",
                    reference: "name",
                    editable: false,
                    formatters: [],
                    base: "item",
                    schema: {
                        details: {
                            type: "single",
                            subtype: "string",
                            formatters: ["lowercase"],
                            allowed_values: [],
                            validators: [],
                        },
                        _id: "53778d501e64109023464019",
                        required: true,
                        searchable: true,
                        filterable: true,
                        display_to_buyers: true,
                        display: true,
                        unique: false,
                        key: "name",
                        name: "Name",
                    },
                },
                {
                    type: "field",
                    reference: "style_number",
                    editable: false,
                    formatters: [],
                    base: "item",
                    schema: {
                        details: {
                            type: "single",
                            subtype: "string",
                            formatters: [],
                            allowed_values: [],
                            validators: [],
                        },
                        _id: "53778d501e6410902346401a",
                        required: true,
                        searchable: true,
                        filterable: true,
                        display_to_buyers: true,
                        display: true,
                        unique: true,
                        key: "style_number",
                        name: "Style Number",
                    },
                },
                {
                    type: "field",
                    reference: "color",
                    editable: false,
                    formatters: [],
                    base: "item",
                    schema: {
                        details: {
                            type: "single",
                            subtype: "string",
                            formatters: [],
                            allowed_values: [],
                            validators: [],
                        },
                        _id: "53778d501e6410902346401a",
                        required: true,
                        searchable: true,
                        filterable: true,
                        display_to_buyers: true,
                        display: true,
                        unique: true,
                        key: "color",
                        name: "Color",
                    },
                },
            ],
        },
        {
            key: "pricing",
            elements: [],
        },
        {
            key: "msrp",
            elements: [],
        },
    ],
    schema_id: "58a4da34c28cc40001bcda13",
    key: "item_tile-58a4da34c28cc40001bcda13",
};

export const buildViewRecord = (brandId: string) => {
    viewDefData.brand = brandId;
    return new ViewRecord(viewDefData);
};
